import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { installReadableSnackBarMessages } from './app/@shared/services/readable-error-message';

if (environment.production) {
  enableProdMode();
}

installReadableSnackBarMessages();

platformBrowserDynamic().bootstrapModule(AppModule, {
  applicationProviders: [provideZoneChangeDetection()],
}).catch((err) => {
  console.error('Bootstrap failed:', err ?? '(rejection had no error object — often Keycloak APP_INITIALIZER)');
});
